import { Select } from "antd"
import { useEffect, useState } from 'react';
import { getCities } from "../../../../controllers/entities";
import { SizeType } from "antd/es/config-provider/SizeContext";

interface Props  {
    onChange: (value : string) => void,
    onSearch?: (value : string) => void,
    size? : SizeType,
    defaultValue? : string,
    style? : any,
    disabled? : boolean,
    onClear : () => void,
}
const filterOption = (input: string, option?: { label: string; value: string }) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

const SelectStates= (props: Props) => {
    const [states, setStates] = useState([]);
    const getStates = (list:[]) => {
        const result = list.reduce((accumulator:any, currentValue:any) => {
            const existingState = accumulator.find((e:any) => e.c_digo_dane_del_departamento === currentValue.c_digo_dane_del_departamento);
            if (!existingState) {
                accumulator.push({
                    c_digo_dane_del_departamento: currentValue.c_digo_dane_del_departamento,
                    state: currentValue.departamento,
                    cities: [{ c_digo_dane_del_departamento: currentValue.c_digo_dane_del_departamento, c_digo_dane_del_municipio: currentValue.c_digo_dane_del_municipio, city: currentValue.municipio }]
                });
            } else {
                existingState.cities.push({ c_digo_dane_del_departamento: currentValue.c_digo_dane_del_departamento, c_digo_dane_del_municipio: currentValue.c_digo_dane_del_municipio, city: currentValue.municipio });
            }

            return accumulator;
        }, []);
        return result;
    };
    
    useEffect(() => {
        const readStates = async () => {
            const data:any = getCities();
            const states =  getStates(data);

            setStates(states.map((c: any) => {
                return {
                    value: c.c_digo_dane_del_departamento,
                    label: c.state
                }
            }));
        }
        readStates();
    }, []);
    
    return (
        <div style={{width : '100%'}}>
            <Select
               {...props}
                showSearch
                optionFilterProp="children"
                allowClear
                onClear={() => {
                    if(props.onClear){
                        props?.onClear();
                    }
                }}
                labelInValue
                placeholder='Departamento'
                size={props.size}
                defaultValue={props?.defaultValue || ''}
                style={props.style}
                onChange={(value:any) =>{
                    if(value){
                        props.onChange(value)
                    }
                }}
                filterOption={filterOption}
                options={states}
            />        
        </div>
    );
}

export default SelectStates